export default "__VITE_ASSET__KWt$0P_a__"